import { render, staticRenderFns } from "./NewsLetter.vue?vue&type=template&id=d8d1965a&"
import script from "./NewsLetter.vue?vue&type=script&lang=js&"
export * from "./NewsLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports